import React from 'react';

/**
 * Caricamento a tutto schermo, lo stesso usato nella pagina Risultati:
 * blocca la pagina e dice cosa sta succedendo, così nessun pulsante
 * sembra "morto" mentre si aspetta il server.
 */
export default function LoadingOverlay({ title, subtitle, icon = 'sync' }: { title: string; subtitle?: string; icon?: string }) {
  return (
    <div className="results-loading-overlay" role="status" aria-live="polite">
      <div className="rlo-icon">
        <span className="mi mi-24 spin" style={{ color: '#fff' }}>{icon}</span>
      </div>
      <div className="rlo-title">{title}</div>
      {subtitle && <div className="rlo-sub">{subtitle}</div>}
    </div>
  );
}
